import { ReactComponent as AdminIcon } from "../assets/illustrations/administration.svg";
import { ReactComponent as AlertIcon } from "../assets/illustrations/alert.svg";
import { ReactComponent as ChildhoodIcon } from "../assets/illustrations/childhood.svg";
import { ReactComponent as DeontologyIcon } from "../assets/illustrations/deontology.svg";
import { ReactComponent as DiscriminationIcon } from "../assets/illustrations/discrimination.svg";
import { ReactComponent as OthersIcon } from "../assets/illustrations/others.svg";

export const getIcons = (domain: string) => {
  switch (domain) {
    case "alerte":
      return <AlertIcon />;
    case "autre":
      return <OthersIcon />;
    case "enfance":
      return <ChildhoodIcon />;
    case "discrimination":
      return <DiscriminationIcon />;
    case "administration":
      return <AdminIcon />;
    case "deontologie":
      return <DeontologyIcon />;
    default:
      return null;
  }
};
